import { loadScript } from './loadScript';
import { getNewRelicAgent } from 'newRelicAgent';

export const loadPlayerSDK = ({ playerDomain }) => {
  const options = {
    src: `https://${playerDomain}/v2/embed.js`,
    id: 'player-embed-js',
    async: true,
  };

  return loadScript(options).catch(() => {
    getNewRelicAgent().noticeError(new Error('MI-PlayerSDK can not be loaded.'));
  });
};
